import styles from './asterisk.module.scss';

const Asterisk = () => {
  return <span className={styles.asterisk}>*</span>;
};

export default Asterisk;
